import { fabric } from 'fabric'

/** 重写控制器样式 */
function drawControl(control, ctx, image, left, top) {
  if (!this.isControlVisible(control)) {
    return
  }
  var size = this.cornerSize
  ctx.beginPath()
  ctx.arc(left + size / 2, top + size / 2, size / 2, 0, 2 * Math.PI, false)
  ctx.strokeStyle = 'white'
  ctx.lineWidth = size / 8
  ctx.stroke()
  ctx.fillStyle = '#FF543E'
  ctx.fill()

  switch (control) {
    case 'tl':
    case 'tr':
    case 'bl':
    case 'br':
      ctx.drawImage(image, left + 1, top + 1, size - 2, size - 2)
      break
    default:
      break
  }
}

/** 重写控制器边框 */
function drawBorders(ctx, styleOverride) {
  styleOverride = styleOverride || {}
  var wh = this._calculateCurrentDimensions()
  var strokeWidth = 1 / this.borderScaleFactor
  var width = wh.x + strokeWidth
  var height = wh.y + strokeWidth

  ctx.save()
  ctx.strokeStyle = styleOverride.borderColor || this.borderColor
  this._setLineDash(
    ctx,
    styleOverride.borderDashArray || this.borderDashArray,
    null
  )
  ctx.strokeRect(-width / 2, -height / 2, width, height)
  ctx.restore()
  return this
}

function render(ctx, left, top, styleOverride, fabricObject) {
  var size =
    this.cornerSize || styleOverride.cornerSize || fabricObject.cornerSize
  const fillStyle =
    styleOverride.borderColor || fabricObject.borderColor || '#ff0136'
  var image =
    fabricObject.customControl && fabricObject.customControl[this.actionName]
      ? fabricObject.customControl[this.actionName].image
      : this.image
  ctx.save()
  ctx.translate(left, top)
  ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle))

  ctx.beginPath()
  ctx.arc(0, 0, size / 2, 0, 2 * Math.PI, false)
  ctx.strokeStyle = 'white'
  ctx.lineWidth = size / 8
  ctx.stroke()
  ctx.fillStyle = fillStyle
  ctx.fill()

  ctx.drawImage(image, -size / 2, -size / 2, size, size)
  ctx.restore()
}

export { drawBorders, drawControl, render }
